<template>
    <div>
        <v-card v-show="!showItemPicker">
            <v-toolbar flat color="info" height="40" >
                <v-toolbar-title>
                    {{title}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.prevent="closeItemEdit()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-form ref="quoteItemform" v-model="itemFormValid" lazy-validation>
                <v-card-text>
                    <v-alert v-show="hasPromotions"
                        v-for="promotion in itemData.promotions"
                        :key="promotion.id"
                        :value="true"
                        type="info"
                        >
                        {{ getPromotionMessage(promotion) }}
                    </v-alert>
                    <v-layout>
                        <v-flex xs12>
                            <v-checkbox
                                v-model="isCustomItem"
                                label="This is a custom item, I will enter data manually"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-text-field 
                            :rules="[rules.required]"
                            v-model="itemData.catalogNum" 
                            label="Catalog #"
                            :readonly="!isCustomItem"
                            type="text"
                            >
                                <v-menu
                                slot="append-outer"
                                style="top: -12px"
                                offset-y
                                v-show="!isCustomItem"
                                >
                                    <v-btn slot="activator" color="primary" @click="showItemPicker=true">
                                        <!-- <v-icon left>menu</v-icon> -->
                                        Pick Item
                                    </v-btn>
                                    <!-- <v-card>
                                        <v-card-text class="pa-4">
                                        <v-btn large flat color="primary" ><v-icon left>mdi-target</v-icon>Click me</v-btn>
                                        </v-card-text>
                                    </v-card> -->
                                </v-menu>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.description" 
                                label="Desc."
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.qty" 
                                type="number"
                                label="Qty."
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field 
                                v-model="itemData.unit" 
                                label="Unit"
                                disabled
                                ></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs4>
                            <v-text-field 
                                v-model="itemData.discountPct" 
                                type="number"
                                label="Discount"
                                suffix="%"
                                ></v-text-field>
                        </v-flex> -->
                        <v-flex xs12 sm12>
                            <v-text-field 
                                v-model="itemData.notes" 
                                label="Internal Notes"
                                ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs-12 pt-3 class="text-xs-center">
                            <v-btn :disabled="!itemFormValid" @click="onSaveItem">Done</v-btn>
                            <!-- <v-btn @click="clear">clear</v-btn> -->
                        </v-flex>
                        <v-flex xs-12 pt-3 class="text-xs-center">
                            <v-btn :disabled="!itemFormValid" @click="onSaveItemAndMore">Done and Pick Next</v-btn>
                            <!-- <v-btn @click="clear">clear</v-btn> -->
                        </v-flex>
                    </v-layout>

                </v-card-text>

            </v-form>

            <!-- {{itemData}} -->
        </v-card>
            <ctlItemSearch @onItemPicked="onItemPicked" v-show="showItemPicker" :resetKeyword="resetKeyword"></ctlItemSearch>
    </div>
</template>
<script>
import ctlItemSearch from '@/components/ctlItemSearch'
import { mapGetters, mapActions } from "vuex";

export default {
    props: ['originalItemData'],
    components: {
        ctlItemSearch
    },
    data () {
        return {
            isCustomItem: false,
            itemData: {},
            showItemPicker: false,
            itemFormValid: false,
            resetKeyword: '',
            rules: {
                required: v => !!v || "This field is required"
            },
        }
    },
    computed: {
        isNew () {
            return !this.originalItemData
        },
        title () {
            return this.isNew? 'Add Item' : 'Edit Item'
        },
        hasPromotions() {
            return this.itemData.promotions
        }
        // itemData () {
        // },
        // isCustomItem () {
        //     if (this.isNew) {
        //         return false
        //     } else {
        //         // if it has itemId, it is an HealthMark inventory item
        //         return !!this.originalItemData.itemId
        //     }
        // },
    },
    methods: {
        ...mapActions('pubQuoteEdit', [
            'saveQuoteItem',
        ]),
        onItemPicked (itemDataPicked) {
            this.showItemPicker = false
            if(itemDataPicked) {
                this.itemData = Object.assign({}, this.itemData, itemDataPicked)
            }
        },
        closeItemEdit () {
            this.$emit('onSaveItem', null)
        },
        // if itemDataToSave == null,it means we will close this popup
        async onSaveItem () {
            // console.table(itemDataToSave)
            if (this.$refs.quoteItemform.validate()) {
                // console.log('onItemPicked called')
                //if quote has id, in our system, it means we will save item to database. 
                if(this.itemData.quoteId) {
                    var result = await this.saveQuoteItem(this.itemData)
                }
                this.$emit('onSaveItem', this.itemData)
 
                //reset itemsearch keyword
                this.resetKeyword = true             
                //reset data for reuse next time
                this.itemData = {}
            }
        },
        async onSaveItemAndMore () {
            // console.table(itemDataToSave)
            if (this.$refs.quoteItemform.validate()) {
                // console.log('onItemPicked called')
                //if quote has id, in our system, it means we will save item to database. 
                if(this.itemData.quoteId) {
                    var result = await this.saveQuoteItem(this.itemData)
                }
                this.$emit('onReloadQuoteData')


                //reset data for reuse next time
                this.itemData = {
                    quoteId: this.itemData.quoteId,
                    active : true,
                }
                this.showItemPicker = true

                this.resetKeyword = false   
            }
        },
        getPromotionMessage(promotion) {
            const maxQty = promotion.maxQty > 0 ? promotion.maxQty : "unlimited";
            if (promotion.promotionType === "BuyXGetYFree") {
                return `Item ${promotion.itemNumber} has Buy ${promotion.buyXGetYFreeBuyQty} Get ${promotion.buyXGetYFreeGetQty} Free promotion. Min. Qty: ${promotion.minQty}, Max. Qty: ${maxQty}, Unit: ${promotion.uom?promotion.uom : 'any'}.`;
            }
            else if (promotion.promotionType === "DiscountPct") {
                return `Item has promotion of ${promotion.promotionAmt}% discount. Min. Qty: ${promotion.minQty}, Max. Qty: ${maxQty}, Unit: ${promotion.uom?promotion.uom : 'any'}. Please ask IS Rep to apply discount.`;
            } else {
                return `Item has a promotional price of $${promotion.promotionAmt}. Min. Qty: ${promotion.minQty}, Max. Qty: ${maxQty}, Unit: ${promotion.uom?promotion.uom : 'any'}. Please ask IS Rep to apply discount.`;
            }
        }
    },
    watch: {
        originalItemData (value) {
            // console.log('originalitemchanged')
            // console.table(value)
            // if (value.itemId) {
            //     this.itemData = {}
            //     this.isCustomItem = false
            // } else {
                this.itemData = Object.assign({}, this.originalItemData)
                // if it has itemId, it is an HealthMark inventory item
                this.isCustomItem = !value.id? false : !value.itemId

            // }

        }
    },
    created() {

    }
}
</script>
